import React, { useEffect, useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import api from '../../services/api';
import SearchSelectField, { SearchOption } from '../SearchSelectField';
import { FiPrinter } from '../../utils/icons';

interface QuestionarioOpcao extends SearchOption {
  id: number;
}

interface SelecionarQuestionarioModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (questionarioId: number) => void;
  titulo: string;
  // Aviso exibido após escolher o questionário — varia por relatório (ex.: Auditoria
  // fala em "constatações" ordenadas por gravidade, Planos de Ação não tem gravidade).
  aviso: string;
}

// Modal de busca de questionário reaproveitado pelas telas de Relatório — mesmo
// padrão de busca com autocomplete já usado em Cadastro de Perguntas (Framework)
// e Cadastro de Pessoas (SearchSelectField).
const SelecionarQuestionarioModal: React.FC<SelecionarQuestionarioModalProps> = ({
  show, onHide, onConfirm, titulo, aviso,
}) => {
  const [opcoes, setOpcoes] = useState<QuestionarioOpcao[]>([]);
  const [loading, setLoading] = useState(false);
  const [selecionado, setSelecionado] = useState<QuestionarioOpcao | null>(null);

  useEffect(() => {
    if (!show) { setSelecionado(null); return; }
    setLoading(true);
    api.getQuestionnaires().then(res => {
      if (res.success && Array.isArray(res.data)) {
        setOpcoes((res.data as any[])
          .filter(q => !q.is_modelo)
          .map(q => ({
            id: q.id,
            key: String(q.id),
            label: q.nome,
            extra: [q.framework, q.is_fechado ? 'Fechado' : 'Em andamento'].filter(Boolean).join(' · '),
          })));
      }
    }).finally(() => setLoading(false));
  }, [show]);

  const handleConfirm = () => {
    if (!selecionado) return;
    onConfirm(selecionado.id);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton><Modal.Title className="fs-5">{titulo}</Modal.Title></Modal.Header>
      <Modal.Body>
        <label className="form-label">Questionário <span className="text-danger">*</span></label>
        <SearchSelectField
          placeholder={loading ? 'Carregando...' : 'Pesquise e selecione o questionário...'}
          disabled={loading}
          options={opcoes}
          value={selecionado ? String(selecionado.id) : ''}
          onSelect={opt => setSelecionado(opt ? (opcoes.find(o => o.key === opt.key) || null) : null)}
        />
        {selecionado && (
          <Alert variant="info" className="mt-3 mb-0 small">
            {aviso}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="primary" onClick={handleConfirm} disabled={!selecionado}>
          <FiPrinter /> Imprimir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelecionarQuestionarioModal;
